var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"investigation-page"},[_c('div',{staticClass:"logo-icon"}),_c('div',{staticClass:"logo-right"}),_c('archives-cover',{attrs:{"survey":_vm.surveyInfo},on:{"begin-test":_vm.beginTest}}),_c('archives-agreement',{ref:"coverRef",attrs:{"statement":_vm.statement},on:{"agree":_vm.handlerAgree}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }